import { createEmptyDocumentFunctionRegistry } from '../../documents/utils/functionRegistry';
import { DocumentFunctionRegistry } from '../../documents/types';
import { SchemaConditionalsRenderer } from '../conditionals/SchemaConditionalsRenderer';

export const buildPolicyDocumentFunctions =
    (): DocumentFunctionRegistry => {
        const base = createEmptyDocumentFunctionRegistry();

        return {
            ...base,
            customInputs: {
                ...base.customInputs,
                conditionals: SchemaConditionalsRenderer,
            },
        };
    };
